import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Navbar = _resolveComponent("Navbar");
    const _component_router_view = _resolveComponent("router-view");
    const _component_SiteFooter = _resolveComponent("SiteFooter");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_Navbar),
        _createVNode(_component_router_view),
        _createVNode(_component_SiteFooter)
    ], 64));
}
